export default __webpack_public_path__ + "static/media/wp1859207.266a4fa4.jpg";